import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_TEMP_AUTH_NUMBER_REQUEST: '',
  GET_TEMP_AUTH_NUMBER_SUCCESS: '',
  GET_TEMP_AUTH_NUMBER_FAILURE: '',

  CHECK_TEMP_AUTH_NUMBER_REQUEST: '',
  CHECK_TEMP_AUTH_NUMBER_SUCCESS: '',
  CHECK_TEMP_AUTH_NUMBER_FAILURE: '',
};

types = setStoreTypeValues(types, 'authTempAuthNumber');

export default types;
